module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA3.1a7877ff.jpg";